import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AppConfigService } from "@app-shared/services";
import { HttpUtilHelper } from "src/shared/helpers/http-util-helper";
import { GetDefaultRatingForMPFBankRequest } from "./models/GetDefaultRatingForMPFBankRequest";
import { GetDefaultRatingForMPFBankApiResponse } from "./models/GetDefaultRatingForMPFBankApiResponse";
import { GetCreditRatingAgenciesResponse } from "./models/GetCreditRatingAgenciesResponse";

@Injectable({
    providedIn: 'root'
})
export class CreditRatingService {

    private API_PATH = `${AppConfigService.Settings.Mpf.ApiEndpoint}`;
    private BUILT_API_PATH = `${this.API_PATH}/api/creditenhancement`;
    private API_SERVICE_PATH = `${this.BUILT_API_PATH}/creditrating`;
    private options: object = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    constructor(private http: HttpClient) { }


    getDefaultRatingForMPFBank(req: GetDefaultRatingForMPFBankRequest): Observable<GetDefaultRatingForMPFBankApiResponse> {

        return this.http.get<GetDefaultRatingForMPFBankApiResponse>(`${this.API_SERVICE_PATH}/${"GetDefaultRatingForMPFBank".toLowerCase()}?${HttpUtilHelper.ConvertQueryString(req)}`, this.options)
            .pipe(map(response => response));
    }

    getAllCreditRatingAgencies(): Observable<GetCreditRatingAgenciesResponse> {
            return this.http.get<GetCreditRatingAgenciesResponse>(`${this.API_SERVICE_PATH}/${"getAllCreditRatingAgencies".toLowerCase()}`, this.options)
                .pipe(map(response => response));
        }

}
